import { NgModule } from '@angular/core';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
//import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImageCropperModule } from 'ngx-image-cropper';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

@NgModule({
  imports: [BsDatepickerModule.forRoot()],
  exports: [
    CKEditorModule,
    CommonModule,
    HttpClientJsonpModule,
    //ScrollingModule,
    BsDatepickerModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ImageCropperModule
  ]
})
export class SharedGlobalModule { }
